import { render } from "./GrayCheck.vue?vue&type=template&id=b9542b90&ts=true"
import script from "./GrayCheck.vue?vue&type=script&lang=ts"
export * from "./GrayCheck.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__